export const environment = {
  inDev: false,
  production: true,
  useHash: false,
  qa: false,
  aws: {
    cognito: {
      UserPoolId: "eu-west-1_QmmQCov9f",
      ClientId: "65sojvg4l9uj9df95as4pqtbfn",
    },
    iot: {
      IdentityPoolId: "eu-west-1:b6205a80-e01f-4dae-989c-2c25db77725d",
      Region: "eu-west-1",
      Login: "cognito-idp.eu-west-1.amazonaws.com/eu-west-1_QmmQCov9f",
      Connection: {
        protocol: "wss",
        host: "a2zakvj3qmc4rf-ats.iot.eu-west-1.amazonaws.com",
        port: 443,
      },
    },
  },
  uiApi: {
    url: "https://uiapi.edpredy.net",
  },
  api: {
    url: "https://redy.edp.pt",
    clientId: "edpportal",
    clientSecret: "15125383-0BFF-4945-B557-D2AC31D1A1AE",
  },
  messagingApi: {
    url: "https://uiapi.edpredy.com",
    apiHeaderKey: "x-api-key",
    apiHeaderValue: "hh7rceai4AnOUroaNDgB9NhuUfUJUP33mkdo2Yb5",
  },
  analytics: {
    url: "https://redy-analytics.corp.edp.pt:8230/api/v1",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts